import * as React from 'react';
import Button from '../components/Button';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import banner from '../../assets/banner.png'

export default function ProductHero() {
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${banner})`,
        backgroundColor: '#7fc7d9', // Average color of the background image.
        backgroundPosition: 'center',
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: 'none' }}
        src={banner}
        alt="increase priority"
      />
      <Typography color="inherit" align="center" variant="h2" marked="center">
        Quickbooks Vendor Timesheets
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        size="large"
        component="a"
        href="/#howitworks"
        sx={{ minWidth: 200 }}
      >
        Learn More
      </Button>
      <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
        Improving Vendor payments and billing via Google Sheets
      </Typography>
    </ProductHeroLayout>
  );
}
